
/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class StockReportRecordForCSV {
  Depot: string;
  Site: string;
  Customer: string;
  Contract: string;
  Scaffold: string;
  ScaffoldingSystem: string;
  QuoteNumber: string;
  ItemNumber: string;
  SiteTotalTonnage: string;
  SiteHandedOverTonnage: string;
  SiteAllocatedTonnage: string;
  SiteIdleTonnage: string;
  ContractMaximumTonnage: string;
  ContractStandingTonnage: string;
  ScaffoldHandoverStatus: string;
  ScaffoldMaximumTonnage: string;
  ScaffoldStandingTonnage: string;
}


